
import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Paper,
  IconButton,
  InputAdornment,
  Divider
} from "@mui/material";

// ✅ MUI Icons
import {
  Visibility,
  VisibilityOff,
  EmailOutlined,
  LockOutlined,
  Facebook,
  Apple
} from "@mui/icons-material";
import GoogleIcon from "@mui/icons-material/Google";

import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import AuthViewController from "../redux/actions/AuthViewController";
import ResumeImg from "../assets/women-8080878_1280.png";
import logo from "../assets/Thryiv_logo_tm_TB.png"
import { Route, useNavigate } from "react-router-dom";
import ForgotPassword from "./ForgotPassword/ForgotPasswordPage";
const LoginPage = () => {
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { login } = AuthViewController();
  const [showForgot, setShowForgot] = useState(false);

  const navigate = useNavigate();
  const onSubmit = (data) => {
    dispatch(login(data));
  };

  return (
    <Grid
      container
      sx={{
        height: "100vh",
        width: "100vw"
      }}
    >
      {/* LEFT PANEL */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          position: "relative", // To contain the overlay
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          p: 4,
          minHeight: "50vh",
          backgroundImage: `url(${ResumeImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      >
        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.6)", // Black overlay with 60% opacity
            zIndex: 1
          }}
        />

        {/* Content */}
        <Box sx={{ position: "relative", zIndex: 2 }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "1.8rem", md: "2.4rem" }
            }}
          >
            Empowering people through seamless HR management.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mt: 2,
              maxWidth: "80%",
              fontSize: { xs: "0.9rem", md: "1rem" }
            }}
          >
            Efficiently manage your workforce, streamline operations
            effortlessly.
          </Typography>
        </Box>
      </Grid>

      {/* RIGHT PANEL */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: "#fff",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: 2, md: 4 }
        }}
      >
        {/* Centered Form */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 400 // max width of form
          }}
        >
          <Paper
            sx={{
              p: 4,
              width: "100%",
              boxShadow: 3,
              borderRadius: 2
            }}
          >
            {/* Logo */}
            <Box display="flex" justifyContent="center" alignItems="center">
              <img
                src={logo}
                alt="Company Logo"
                style={{
                  height: 60,           // adjust height as needed
                  objectFit: "contain", // keeps aspect ratio
                }}
              />
            </Box>

            <Typography
              variant="h6"
              align="center"
              sx={{ mt: 2, fontWeight: "bold", mb: 2 }}
            >
              Sign In
            </Typography>
            {/* <Typography
              variant="body2"
              align="center"
              color="text.secondary"
              sx={{ mb: 3 }}
            >
              Please enter your details to sign in
            </Typography> */}

            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Email */}
              <Controller
                name="identifier"
                control={control}
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email address"
                  }
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Email Address"
                    fullWidth
                    error={!!errors.identifier}
                    helperText={errors.identifier?.message}
                    variant="outlined"
                    autoComplete="email"
                    sx={{ mb: 2 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailOutlined />
                        </InputAdornment>
                      )
                    }}
                  />
                )}
              />

              {/* Password */}
              <Controller
                name="password"
                control={control}
                rules={{
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must be at least 6 characters long"
                  }
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Password"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    variant="outlined"
                    autoComplete="current-password"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlined />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                )}
              />

              {/* Remember me & Forgot password */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 1,
                  mb: 2
                }}
              >
                <label style={{ fontSize: "0.9rem" }}>
                  <input type="checkbox" /> Remember Me
                </label>
                <Typography
                  variant="body2"
                  sx={{ color: "error.main", cursor: "pointer" }}
                  onClick={() => navigate("/forgot-password")}
                >
                  Forgot Password?
                </Typography>
              </Box>

              {/* Sign In Button */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#FF6A00",
                  "&:hover": { backgroundColor: "#E65A00" },
                  mb: 2,
                  py: 1.4
                }}
              >
                Sign In
              </Button>

              {/* Create Account Link */}
              {/* <Typography align="center" variant="body2" sx={{ mb: 2 }}>
                Don’t have an account?{" "}
                <span style={{ color: "#FF6A00", cursor: "pointer" }}>
                  Create Account
                </span>
              </Typography> */}

              {/* <Divider>Or</Divider> */}

              {/* Social Login Buttons with Icons */}
              {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<Facebook />}
                  sx={{
                    backgroundColor: "#1877F2",
                    flex: 1,
                    mr: 1,
                    textTransform: "none",
                  }}
                >
                  Facebook
                </Button>

                <Button
                  variant="contained"
                  startIcon={<GoogleIcon />}
                  sx={{
                    backgroundColor: "#DB4437",
                    flex: 1,
                    mx: 1,
                    textTransform: "none",
                  }}
                >
                  Google
                </Button>

                <Button
                  variant="contained"
                  startIcon={<Apple />}
                  sx={{
                    backgroundColor: "#000",
                    flex: 1,
                    ml: 1,
                    textTransform: "none",
                  }}
                >
                  Apple
                </Button>
              </Box> */}

              {/* Footer */}
              <Typography
                variant="caption"
                display="block"
                align="center"
                sx={{ mt: 4, color: "text.secondary" }}
              >
                Copyright © 2025 - Swatsan Tech Pvt. Ltd.
              </Typography>
            </form>
          </Paper>
        </Box>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
